<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-wrapper winner-page">
            <div class="page-content"
                v-if="isAccountLoaded">
                <nav-bar-winner
                    class="winner-nav"
                    :pageName="navbarName"
                    :title="titleWinner"
                    :imageUrl="imageWinner"
                    :userType="userType"
                    @clickBack="clickBack"></nav-bar-winner>

                <div class="list-winner">
                    <div class="item" v-for="(winner, k) in winnerList" :key="k">
                        <div class="number theme-border-color theme-txt">
                            <div class="text">{{k+1}}</div>
                        </div>
                        <div class="detail">
                            <div class="name">{{winner.split(',')[1].split('|')[0]}}</div>
                            <div class="phone theme-txt">{{lbl.winnerlabel_phone}} {{winner.split(',')[1].split('|')[1]}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-bg"></div>
        </div>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//helper
import Locale from '@/helper/locale/locale.js';
//component
import NavBarWinner from "../component/NavBarWinner.vue";
//service
import LuckyWinnerApi from "../service/LuckyWinnerApi.js";

export default {
    name: 'LuckyWinner',
    mixins: [AccountMixin],
    components: {
        NavBarWinner
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            navbarName: "",
            filename: '',
            titleWinner: '',
            imageWinner: '',
            winner: [],
            winnerList: [],
        }
    },
    created: function () {
        this.navbarName = `${this.lbl.winner.nav_name}`;
        // this.titleWinner = 'แลกส่วนลดพิเศษจากร้าน Swensens มูลค่า 100 บาท';
        // this.imageWinner = 'https://devstoragebuzzebees.blob.core.windows.net/campaigns/92183-large?time=20200827114634';
        this.initialListWinner();
    },
    methods: {
        initialListWinner: function(){
            this.filename = this.$route.params.blobfilename;
            var filename = `${this.filename}.csv`;

            LuckyWinnerApi.apiGetListWinner(filename)
                .then((res) => {
                    this.winner = res.data.split('\n');
                    //console.log(this.winner[0]);

                    if(this.winner[0].split(',')[0] == 'reward'){
                        var reward = this.winner[0].split(',')[1].split('|');
                        this.imageWinner = reward[0];
                        this.titleWinner = reward[1];
                    }

                    for(var i=1;i<this.winner.length-1;i++){
                        this.winnerList.push(this.winner[i]);
                        //console.log(`${i} ${this.winner[i]}`);
                    }

                    
                }).catch((err) => {
                    
                    console.log(err);
                });
            
        },
        clickBack: function () {
            this.$router.push('/home');
        }
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "../style/LuckyWinnerList.scss";
</style>
